<div class="ttmodal" id="schematicDraggable">
    <div id="schematicDraggableheader" class="ttmodal__header">
        <span class="ttmodal__title">Implement Schematics</span>
        <div class="panel__header__button-container">
            <a class="button waves-effect" (click)="onCloseClick()">
                <i class="material-icons button__icon">cancel</i>
                <span class="button__text">Close</span>
            </a>
        </div>
    </div>
    <div class="ttmodal__body">
        <app-carousel>
            <ng-container *ngFor="let sch of schematics">
                <ng-container *carouselItem>
                    <input type="hidden" [value]="sch.Id" />
                    <img [src]="getImage(sch.Data)" style="width: 640px; height: 520px;" />
                    <ng-container *ngFor="let cp of sch.GETComponents">
                        <i *ngIf="getEval(cp.WornPct, cp.InspectionDate) == 'green'" class="material-icons button__icon green-eval" 
                           matTooltip="{{cp.Name}} ({{cp.WornPct}}% Worn) Last Inspection - {{cp.InspectionDate}}"
                           [style]="getPosition(cp.PositionX, cp.PositionY)">lens</i>

                        <i *ngIf="getEval(cp.WornPct, cp.InspectionDate) == 'yellow'" class="material-icons button__icon yellow-eval"
                           matTooltip="{{cp.Name}} ({{cp.WornPct}}% Worn) Last Inspection - {{cp.InspectionDate}}"
                           [style]="getPosition(cp.PositionX, cp.PositionY)">lens</i>

                        <i *ngIf="getEval(cp.WornPct, cp.InspectionDate) == 'orange'" class="material-icons button__icon orange-eval"
                           matTooltip="{{cp.Name}} ({{cp.WornPct}}% Worn) Last Inspection - {{cp.InspectionDate}}"
                           [style]="getPosition(cp.PositionX, cp.PositionY)">lens</i>

                        <i *ngIf="getEval(cp.WornPct, cp.InspectionDate) == 'red'" class="material-icons button__icon red-eval"
                           matTooltip="{{cp.Name}} ({{cp.WornPct}}% Worn) Last Inspection - {{cp.InspectionDate}}"
                           [style]="getPosition(cp.PositionX, cp.PositionY)">lens</i>

                        <i *ngIf="getEval(cp.WornPct, cp.InspectionDate) == 'gray'" class="material-icons button__icon no-eval"
                           matTooltip="{{cp.Name}} ({{cp.WornPct}}% Worn) Last Inspection - {{cp.InspectionDate}}"
                           [style]="getPosition(cp.PositionX, cp.PositionY)">lens</i>
                    </ng-container>
                </ng-container>
            </ng-container>
        </app-carousel>
    </div>
</div>